import AuthService from '@/services/auth.js'

export default {
  components: {},

  data() {
    return {
      password: '',
      confirm_password: '',
    }
  },

  computed: {},

  created() {
    this.$store.dispatch('navigator/goNextState', { page: 'register', tab: '' })
  },
  mounted() {
    $('.container').css("padding", "unset")
    $('.container').css("height", "100vh")
  },

  methods: {
    submit() {
      const vm = this
      this.$validator
        .validateAll()
        .then(function (response) {
          if (response === true) {
            const params = {
              reset_token: vm.$route.params.token,
              password: vm.password,
            }
            AuthService.resetPassword(params)
              .then(() => {
                vm.$store.dispatch('error/showSuccessToast', [
                  'Password has been updated successfully.',
                ])
                vm.$router.push({ path: '/login' })
              })
              .catch((e) => {
                vm.$store.dispatch(
                  'error/showErrorToast',
                  // e.body.errors || [e.body]
                  vm._.map(
                    e.body.errors,
                    (msg) => `reset_password_token ${msg.detail}`
                  )
                )
              })
          }
        })
        .catch(function (e) {
          console.log('error', e)
        })
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/auth/reset_password.ctrl.js